import { render, staticRenderFns } from "./GraphDetail83.vue?vue&type=template&id=4ffc18f2&scoped=true&"
import script from "./GraphDetail83.vue?vue&type=script&lang=js&"
export * from "./GraphDetail83.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ffc18f2",
  null
  
)

export default component.exports